<template>
  <el-menu
    :default-active="$route.path"
    :default-openeds="['data']"
    class="my-el-menu-no-border"
    :router="true"
    background-color="#313E63"
    text-color="#BCBCBC"
    active-text-color="#FFFFFF">
    <el-submenu index="data">
      <template slot="title">
        <div class="data_menu_title">
          <i class="iconfont iconshujufuwu"></i>
          <span>数据服务</span>
        </div>
      </template>
        <el-menu-item index="/index/dataServer/pendingOrder">
          <span slot="title">
            待处理订单
          </span>
        </el-menu-item>
      <el-menu-item index="/index/dataServer/processedOrder">
        <span slot="title">处理中订单</span>
      </el-menu-item>
      <el-menu-item index="/index/dataServer/historyOrder">
        <span slot="title">历史订单</span>
      </el-menu-item>
      <el-menu-item index="/index/dataServer/rejectOrder">
        <span slot="title">拒绝的订单</span>
      </el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
export default {
  methods: {
    // 打开
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    // 关闭
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    }
  },
  computed: {
    path () {
      return this.$route.path
    }
  }
}
</script>
<style lang="scss" scoped>
  .data_menu_title {
    display: flex;
    align-items: center;
    height: 100%;
    color: #ffffff;
    & > i {
      color: #ffffff;
      margin-right: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/aside/aside-content.vue